export class OverMileageLeaseQueryParameters {
  actioned?: string;
  equityThreshold?: number;
  inEquity?: string;
  originalSalespersonId?: string;
  page?: number;
  pageSize?: number;
  rooftopId?: string;
  salespersonId?: string[];
  saleTypeId?: string[];
  sort?: string;
  termFrom?: number;
  termTo?: number;
  userEmployeeId?: string;
  vehicleId?: string;

  constructor(obj?: OverMileageLeaseQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
